var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { toURLSearchParams } from "utils";
export function makeSearchQueryFromURLParams(query) {
    const searchParams = new URLSearchParams(query);
    const queryObj = [...searchParams.keys()].reduce((acc, x) => {
        const values = searchParams.getAll(x);
        acc[x.toLowerCase()] = values.length > 1 ? values : values[0];
        return acc;
    }, {});
    const page = parseInt(queryObj['page']) || 0;
    delete queryObj['page'];
    return [queryObj, page];
}
export function makeNewTourSearchQueryFromURLParams(query) {
    const searchParams = new URLSearchParams(query);
    const queryObj = {};
    searchParams.forEach((value, key) => {
        const match = key.match(/^([^\[]+)\[(\d+)\]$/);
        if (match) {
            const [, arrayKey, indexRaw] = match;
            const index = parseInt(indexRaw);
            queryObj[arrayKey] = queryObj[arrayKey] || [];
            queryObj[arrayKey][index] = normalizeSearchParamValue(value);
            return;
        }
        if (key == 'page')
            return;
        queryObj[key] = normalizeSearchParamValue(value);
    });
    const page = parseInt(searchParams.get('page') || '') || 0;
    return [queryObj, page];
}
function normalizeSearchParamValue(value) {
    if (value == 'true')
        return true;
    if (value == 'false')
        return false;
    if (/^-?\d+$/.test(value))
        return parseInt(value);
    return value;
}
export function makeSearchId(query, page) {
    const { page: _ } = query, queryBlob = __rest(query, ["page"]);
    const searchParams = toURLSearchParams(queryBlob);
    searchParams.set('page', page + '');
    return searchParams.toString();
}
export function mapExtrasToJsonCompatibility(extras) {
    return Object.keys(extras).filter(key => { var _a; return !!((_a = extras[key]) === null || _a === void 0 ? void 0 : _a.length); }).map(key => ({ key, value: extras[key] }));
}
export function getExtraKey(e) {
    return e.groupByPackage ? `${e.packageId}-${e.day}` : e.compositeId;
}
